/* eslint-disable react-hooks/exhaustive-deps */
import { Card } from "../../../components/card.component";
import React, { useCallback, useState } from "react";
import { CompanyList } from "../../../features/company/companyList.component";
import searchIcon from "../../../assets/img/search-icon.svg";
import { useEffect } from "react";
import {
  ActionsCompanyTable,
  useAppDispatch,
  useAppSelector,
} from "../../../core/redux";
import { ExportButton } from "../../../components/export.component";
import { debounce } from "../../../utils";

export const PageCompanyView = () => {
  const dispatch = useAppDispatch();
  const { pageNumber, pageSize, searchKey } = useAppSelector(
    (state) => state.companyTable
  );
  const [tempSearchKey, setTempSearchKey] = useState(searchKey);

  const searchCompanyList = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>): void => {
      setTempSearchKey(event.target.value);
      debounce(() => {
        dispatch(ActionsCompanyTable.goToPage(1));
        dispatch(ActionsCompanyTable.setSearchKey(event.target.value));
      });
    },
    []
  );

  useEffect(() => {
    return () => {
      dispatch(ActionsCompanyTable.resetData());
    };
  }, [dispatch]);

  return (
    <Card
      header={
        <div className="row align-items-center  justify-content-between">
          <div className="col-md-8 col-12 content-box-title">
            <div>
              <p className="text-capitalize my-1 text-green-200">
                Manage Company
              </p>
            </div>
            <div className="collapse-icon"></div>
          </div>
          <div className="col-md-4 col-12 mt-1">
            <form className="search-component">
              <div className="input-group me-3">
                <span
                  className="input-group-text pe-2"
                  id="search-component-word"
                >
                  <img src={searchIcon} alt="search-icon" />
                </span>
                <input
                  type="text"
                  className="form-control ps-0"
                  placeholder="Search..."
                  aria-label="Search"
                  aria-describedby="search-component-word"
                  onChange={searchCompanyList}
                  value={tempSearchKey}
                  onKeyPress={(ev) => {
                    ev.key === "Enter" && ev.preventDefault();
                  }}
                />
                {searchKey.length > 0 && (
                  <span
                    className="input-group-text text-green-200"
                    id="search-component-word"
                  >
                    <i
                      className="fas fa-times click"
                      onClick={() => {
                        setTempSearchKey("");
                        dispatch(ActionsCompanyTable.setSearchKey(""));
                      }}
                    />
                  </span>
                )}
              </div>
              <ExportButton
                params={{ pageNumber, pageSize, searchKey }}
                component="Company"
              />
            </form>
          </div>
        </div>
      }
    >
      <CompanyList />
    </Card>
  );
};
